import React from "react"
import ChatIcon from '@mui/icons-material/Chat'
import DashboardIcon from '@mui/icons-material/Dashboard'

// Tool enum for consistent referencing across the app
export const TOOLS = {
  MARKET_OVERVIEW: 'MARKET_OVERVIEW',
  TICKER_REPORT: 'TICKER_REPORT',
  MAX_PAIN: 'MAX_PAIN',
  OPTION_PRICER: 'OPTION_PRICER',
  SPREAD_FINDER: 'SPREAD_FINDER',
  CONDOR_BUILDER: 'CONDOR_BUILDER',
  PUT_CALL_RATIOS: 'PUT_CALL_RATIOS',
  CHAT: 'CHAT'
};

// Central configuration for all tools
export const tools = {
  [TOOLS.MARKET_OVERVIEW]: {
    pageTitle: "Market Overview",
    link: "/",
    icon: {
      element: <DashboardIcon />,
      component: "DashboardIcon",
      type: "mui"
    }
  },
  [TOOLS.TICKER_REPORT]: {
    pageTitle: "Ticker Report",
    link: "/tickerreport/",
    icon: {
      element: <i className="fas fa-file-alt"></i>,
      component: "fa-file-alt",
      type: "fontawesome"
    }
  },
  [TOOLS.MAX_PAIN]: {
    pageTitle: "Max Pain Calculator",
    link: "/maxpain/",
    icon: {
      element: <i className="fas fa-balance-scale"></i>,
      component: "fa-balance-scale",
      type: "fontawesome"
    }
  },
  [TOOLS.OPTION_PRICER]: {
    pageTitle: "Option Price Visualizer",
    link: "/optionpricer/",
    icon: {
      element: <i className="fas fa-calculator"></i>,
      component: "fa-calculator",
      type: "fontawesome"
    }
  },
  [TOOLS.SPREAD_FINDER]: {
    pageTitle: "Vertical Spread Finder",
    link: "/spreadfinder/",
    icon: {
      element: <i className="fas fa-arrows-alt-h"></i>,
      component: "fa-arrows-alt-h",
      type: "fontawesome"
    }
  },
  [TOOLS.CONDOR_BUILDER]: {
    pageTitle: "Iron Condor Builder",
    link: "/condorbuilder/",
    icon: {
      element: <i className="fas fa-fighter-jet"></i>,
      component: "fa-fighter-jet",
      type: "fontawesome"
    }
  },
  [TOOLS.PUT_CALL_RATIOS]: {
    pageTitle: "Put/Call Ratio Chart (SPY / S&P 500) - Equity Options Open Interest",
    shortDescription: "Put/Call Ratios",
    link: "/pcratios/",
    icon: {
      element: <i className="fas fa-percent"></i>,
      component: "fa-percent",
      type: "fontawesome"
    }
  },
  [TOOLS.CHAT]: {
    pageTitle: "Options Chat",
    link: "/chat/",
    icon: {
      element: <ChatIcon />,
      component: "ChatIcon",
      type: "mui"
    }
  }
};

// Helper function to get icon for a tool
export const getToolIcon = (toolKey) => {
  return tools[toolKey]?.icon?.element || null;
};

// Helper function to check if tool has an icon
export const hasIcon = (toolKey) => {
  return tools[toolKey]?.icon?.element !== null;
};

// Helper function to get page title for a tool
export const getToolPageTitle = (toolKey) => {
  return tools[toolKey]?.pageTitle || "";
};

// Helper function to get link for a tool
export const getToolLink = (toolKey) => {
  return tools[toolKey]?.link || "/";
};

// Helper function to get display name for a tool (short description if exists, otherwise page title)
export const getToolDisplayName = (toolKey) => {
  return tools[toolKey]?.shortDescription || tools[toolKey]?.pageTitle || "";
};

